/*
 * Cathy Allan — "champagne burst" fireworks
 * Elevated, restrained fireworks bound to a single sale button.
 * - Canvas 2D, additive glow, real physics (gravity + drag + fade)
 * - Brand palette only (pink / deep rose / champagne gold / warm white cores)
 * - One deliberate burst per trigger, debounced
 * - Respects prefers-reduced-motion; overlay never steals clicks
 *
 * Usage: CAFireworks.bind(buttonEl [, options])
 */
(function (window, document) {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var DEFAULTS = {
    // weighted palette — mostly pink/rose, gold as the luxe accent, white cores are rare
    palette: [
      { c: '#be3d7d', w: 5 }, // brand pink
      { c: '#a22663', w: 3 }, // deep rose
      { c: '#E8C87E', w: 3 }, // champagne gold
      { c: '#FFF6FB', w: 1 }  // warm white core
    ],
    particles: 90,     // per shell
    shells: 1,         // shells launched per trigger (loud = 3)
    shellStagger: 230, // ms between shells
    gravity: 0.045,
    drag: 0.986,
    riseMs: 620,       // rocket ascent time
    riseHeight: 0.42,  // fraction of canvas height the rocket climbs
    debounceMs: 900,
    mobile: true       // fire once on scroll-into-view for no-hover devices
  };

  function pickWeighted(palette) {
    var total = 0, i;
    for (i = 0; i < palette.length; i++) total += palette[i].w;
    var r = Math.random() * total;
    for (i = 0; i < palette.length; i++) {
      r -= palette[i].w;
      if (r <= 0) return palette[i].c;
    }
    return palette[0].c;
  }

  function Show(canvas, opts) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.opts = opts;
    this.dpr = Math.min(window.devicePixelRatio || 1, 2);
    this.particles = [];
    this.rockets = [];
    this.raf = null;
    this.last = 0;
    this.resize();
  }

  Show.prototype.resize = function () {
    var r = this.canvas.getBoundingClientRect();
    this.w = r.width; this.h = r.height;
    this.canvas.width = Math.round(r.width * this.dpr);
    this.canvas.height = Math.round(r.height * this.dpr);
    this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
  };

  // launch a rocket from (x,y) in canvas-local coords
  Show.prototype.launch = function (x, y) {
    var o = this.opts;
    var targetY = y - this.h * o.riseHeight - Math.random() * 40;
    this.rockets.push({
      x: x, y: y,
      sx: (Math.random() - 0.5) * 0.6,      // slight lateral drift
      startY: y, targetY: targetY,
      t: 0, dur: o.riseMs,
      trail: []
    });
    if (!this.raf) this.loop(0);
  };

  Show.prototype.burst = function (x, y) {
    var o = this.opts, n = o.particles, i;
    for (i = 0; i < n; i++) {
      var ang = Math.random() * Math.PI * 2;
      // gaussian-ish speed so the shell has a soft edge, not a hard ring
      var speed = (Math.random() + Math.random() + Math.random()) / 3 * 4.4 + 0.6;
      var upBias = -0.6; // slight upward lift so it feels buoyant
      this.particles.push({
        x: x, y: y,
        vx: Math.cos(ang) * speed,
        vy: Math.sin(ang) * speed + upBias,
        color: pickWeighted(o.palette),
        life: 0,
        ttl: 70 + Math.random() * 55,   // frames
        size: 1.3 + Math.random() * 1.7,
        trail: [],
        twinkle: Math.random() * Math.PI * 2
      });
    }
  };

  Show.prototype.loop = function (ts) {
    var self = this;
    if (!this.last) this.last = ts;
    this.last = ts;
    var ctx = this.ctx, o = this.opts;

    ctx.clearRect(0, 0, this.w, this.h);
    ctx.globalCompositeOperation = 'lighter';

    // rockets
    for (var r = this.rockets.length - 1; r >= 0; r--) {
      var rk = this.rockets[r];
      rk.t += 16.7;
      var p = Math.min(rk.t / rk.dur, 1);
      var ease = 1 - Math.pow(1 - p, 2); // decelerate as it peaks
      rk.x += rk.sx;
      rk.y = rk.startY + (rk.targetY - rk.startY) * ease;
      rk.trail.push({ x: rk.x, y: rk.y });
      if (rk.trail.length > 8) rk.trail.shift();
      // draw rocket trail
      for (var ti = 0; ti < rk.trail.length; ti++) {
        var a = ti / rk.trail.length;
        this.dot(rk.trail[ti].x, rk.trail[ti].y, 1.6 * a + 0.4, '#FFF6FB', a * 0.9);
      }
      if (p >= 1) {
        this.burst(rk.x, rk.y);
        this.rockets.splice(r, 1);
      }
    }

    // particles
    for (var i = this.particles.length - 1; i >= 0; i--) {
      var pt = this.particles[i];
      pt.life++;
      pt.vx *= o.drag;
      pt.vy = pt.vy * o.drag + o.gravity;
      pt.x += pt.vx;
      pt.y += pt.vy;

      var lifeRatio = pt.life / pt.ttl;
      if (lifeRatio >= 1) { this.particles.splice(i, 1); continue; }

      // fade: hold bright, then ease out; twinkle shimmer near the end
      var alpha = 1 - lifeRatio * lifeRatio;
      var shimmer = lifeRatio > 0.55 ? (0.7 + 0.3 * Math.sin(pt.life * 0.5 + pt.twinkle)) : 1;
      alpha *= shimmer;
      var size = pt.size * (1 - lifeRatio * 0.5);

      // short trail
      pt.trail.push({ x: pt.x, y: pt.y });
      if (pt.trail.length > 5) pt.trail.shift();
      for (var k = 0; k < pt.trail.length - 1; k++) {
        var ta = (k / pt.trail.length) * alpha * 0.5;
        this.dot(pt.trail[k].x, pt.trail[k].y, size * 0.6, pt.color, ta);
      }
      this.dot(pt.x, pt.y, size, pt.color, alpha);
    }

    if (this.particles.length || this.rockets.length) {
      this.raf = window.requestAnimationFrame(function (t) { self.loop(t); });
    } else {
      ctx.clearRect(0, 0, this.w, this.h);
      this.raf = null; this.last = 0;
    }
  };

  // soft glowing dot via radial gradient (the bloom that reads "elevated")
  Show.prototype.dot = function (x, y, size, color, alpha) {
    var ctx = this.ctx;
    var glow = size * 4;
    var g = ctx.createRadialGradient(x, y, 0, x, y, glow);
    g.addColorStop(0, hexA(color, alpha));
    g.addColorStop(0.25, hexA(color, alpha * 0.55));
    g.addColorStop(1, hexA(color, 0));
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(x, y, glow, 0, Math.PI * 2);
    ctx.fill();
  };

  function hexA(hex, a) {
    var h = hex.replace('#', '');
    var n = parseInt(h, 16);
    var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    return 'rgba(' + r + ',' + g + ',' + b + ',' + Math.max(0, Math.min(1, a)) + ')';
  }

  function ensureCanvas(host) {
    var c = host.querySelector('canvas[data-ca-fireworks]');
    if (c) return c;
    c = document.createElement('canvas');
    c.setAttribute('data-ca-fireworks', '');
    c.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:5;';
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(c);
    return c;
  }

  var API = {
    bind: function (btn, options) {
      if (!btn || REDUCED) return; // elevated = silent under reduced-motion
      if (btn.__caFw) return btn.__caFw; // already bound
      var opts = Object.assign({}, DEFAULTS, options || {});
      var host = (options && options.host) || btn.closest('[data-fireworks-host]') || btn.parentElement;
      var canvas = ensureCanvas(host);
      var show = new Show(canvas, opts);
      var lastFire = 0;

      window.addEventListener('resize', function () { show.resize(); });

      function fireFromButton(force) {
        var now = Date.now();
        if (!force && now - lastFire < opts.debounceMs) return;
        lastFire = now;
        var hostRect = host.getBoundingClientRect();
        var b = btn.getBoundingClientRect();
        var cx = b.left + b.width / 2 - hostRect.left;
        var cy = b.top + b.height / 2 - hostRect.top;
        for (var s = 0; s < opts.shells; s++) {
          (function (i) {
            setTimeout(function () {
              var jitter = opts.shells > 1 ? (Math.random() - 0.5) * b.width * 1.6 : 0;
              show.launch(cx + jitter, cy);
            }, i * opts.shellStagger);
          })(s);
        }
      }

      btn.addEventListener('mouseenter', function () { fireFromButton(false); });
      btn.addEventListener('focus', function () { fireFromButton(false); });
      // touch / no-hover: fire once when it scrolls into view
      if (opts.mobile !== false && window.IntersectionObserver && matchMedia('(hover: none)').matches) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { fireFromButton(true); io.disconnect(); } });
        }, { threshold: 0.6 });
        io.observe(btn);
      }
      var instance = { fire: fireFromButton, show: show };
      btn.__caFw = instance;
      return instance;
    }
  };

  window.CAFireworks = API;

  // Auto-bind any [data-fireworks-trigger], reading options from data-* attributes.
  // Runs on load and on Shopify theme-editor section reloads.
  function autoInit(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-fireworks-trigger]').forEach(function (btn) {
      if (btn.__caBound) return;
      btn.__caBound = true;
      var d = btn.dataset, o = {};
      if (d.fwParticles) o.particles = parseInt(d.fwParticles, 10);
      if (d.fwShells) o.shells = parseInt(d.fwShells, 10);
      if (d.fwMobile === 'off') o.mobile = false;
      API.bind(btn, o);
    });
  }
  if (document.readyState !== 'loading') autoInit();
  else document.addEventListener('DOMContentLoaded', function () { autoInit(); });
  document.addEventListener('shopify:section:load', function (e) { autoInit(e.target); });
})(window, document);
